/* global FS, TD */
import $ from "jquery";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import OverlappingMarkerSpiderfier from "./oms";
import { addCallback } from "./td";

var googleMaps = window.google && window.google.maps;
var userGoogleMapApiKey = window.GoogleMapApiKey;

var locationSupported = "geolocation" in navigator;

document.documentElement.className += (locationSupported ? " " : " no-") + "geolocation";

var initialAspect = (window.innerHeight - 112) / window.innerWidth;

function loadGoogleMapApi(callback) {
	if (!googleMaps) {
		var randomFnName = "gmapcallback" + new Date().valueOf();
		window[randomFnName] = function () {
			googleMaps = window.google.maps;
			callback();
			delete window[randomFnName];
		};
		var googleMapApiKey = userGoogleMapApiKey || (window.gApiConfig && window.gApiConfig.gmapapikey);
		FS.addScript("//maps.googleapis.com/maps/api/js?libraries=places&key=" + googleMapApiKey + "&callback=" + randomFnName);
	} else {
		callback();
	}
}

var getLocation = locationSupported ? (function () {
	var callbackQueue = [];
	return function(completion) {
		callbackQueue.push(completion);
		if(callbackQueue.length == 1) {
			navigator.geolocation.getCurrentPosition(
				function (position) {
					var latLng = { lat: round(position.coords.latitude), lng: round(position.coords.longitude) };
					for(var i = 0; i < callbackQueue.length; i++) {
						callbackQueue[i](latLng);
					}
					callbackQueue = [];
				}, function (error) {
					var message;
					switch(error.code) {
						case 1:
							message = TD.Res["location.error.disabled"];
							break;
						case 2:
							message = TD.Res["location.error.failed"];
							break;
						case 3:
							message = TD.Res["location.error.timeout"];
							break;
						default:
							message = error.message;
					}
					for(var i = 0; i < callbackQueue.length; i++) {
						callbackQueue[i](null, message);
					}
					callbackQueue = [];
				});
		}
	};
})() : function (completion) {
	completion(null, TD.Res["location.error.not_supported"]);
};

function round(value) {
	var r = 1000000;
	return Math.round(value * r) / r;
}

function getSpinner() {
	return $("<div>").css({ "position": "absolute", "left": "50%", "top": "50%", "margin-top": "-30px", "margin-left": "-30px" })
		.append($("<div/>", { "class": "ui-spinner" }).append($("<div/>").text(TD.Res["location.loading"])));
}

function autoComplete(input, map, marker, latLng) {
	var autocomplete = new googleMaps.places.Autocomplete(input);
	autocomplete.addListener('place_changed', function() {
		marker.setVisible(false);
		var place = autocomplete.getPlace();
		if(!place.geometry) {
			window.alert("No details available for input: '" + place.name + "'");
			return;
		}
		latLng.lat = round(place.geometry.location.lat());
		latLng.lng = round(place.geometry.location.lng());

		// If the place has a geometry, then present it on a map.
		if(place.geometry.viewport) {
			map.fitBounds(place.geometry.viewport);
		} else {
			map.setCenter(place.geometry.location);
			map.setZoom(17);	// Why 17? Because it looks good.
		}
		marker.setPosition(place.geometry.location);
		marker.setVisible(true);

		input.value = place.formatted_address || '';
	});
}

function initMap(id, spinner, latLng, zoom, type, completeHandler, cancelHandler) {
	if(!latLng) {
		return getLocation(function(latLng, message) {
			if(message) {
				latLng = { lat: 0, lng: 0 };
				zoom = 1;
			}
			initMap(id, spinner, latLng, zoom, type, completeHandler, cancelHandler);
		});
	}
	spinner.remove();
	var editable = completeHandler != null;
	var map = new googleMaps.Map(document.getElementById(id), {
		center: latLng,
		zoom: zoom,
		streetViewControl: false,
		zoomControl: true,
		mapTypeId: type || googleMaps.MapTypeId.ROADMAP,
		mapTypeControl: true,
		mapTypeControlOptions: {
			position: googleMaps.ControlPosition.TOP_RIGHT,
			style: googleMaps.MapTypeControlStyle.DROPDOWN_MENU,
			mapTypeIds: ["roadmap", "terrain", "satellite", "hybrid"]
		}
	});
	var geocoder = new googleMaps.Geocoder();
	var marker = new googleMaps.Marker({
		position: latLng,
		draggable: editable,
		map: map
	});
	var buttonDiv = document.createElement("div");
	buttonDiv.className = "td-mapbuttoncontainer";
	map.controls[googleMaps.ControlPosition.BOTTOM_RIGHT].insertAt(0, buttonDiv);
	if(editable) {
		var div = document.createElement("div");
		div.className = "td-mapinputcontainer";
		var input = $("<input>", { "class": "td-mapinput" }).appendTo(div);
		map.controls[googleMaps.ControlPosition.TOP_LEFT].push(div);
		autoComplete(input[0], map, marker, latLng);
		input.attr("placeholder", TD.Res["location.search"]);
		marker.addListener("dragend", function(evt) {
			latLng.lat = round(evt.latLng.lat());
			latLng.lng = round(evt.latLng.lng());
			geocoder.geocode({ "location": latLng }, function(results, status) {
				var address;
				if(status === "OK" && results.length)
					address = results[0].formatted_address;
				input.val(address || (latLng.lat + ", " + latLng.lng));
			});
		});
	}
	if(completeHandler) {
		$("<button/>", { type: "button" }).text(TD.Res["action.save"]).appendTo(buttonDiv).on("click", function() { completeHandler(latLng); });
	}
	if(cancelHandler) {
		$("<button/>", { type: "button" }).text(TD.Res["action.cancel"]).appendTo(buttonDiv).on("click", cancelHandler);
	}
}

function displayMap(latLng, options, callback) {
	var { zoom, type } = options;
	var id = "td-mapdialog";
	var mapPopup = $("#" + id);
	if(!mapPopup.length)
		mapPopup = $("<div>", { id: id }).appendTo(document.body);
	mapPopup.dialog({
		modal: true,
		draggable: false,
		resizable: false,
		classes: { "ui-dialog": "ui-popup td-map-dialog td-embedded" },
		open: function() {
			$("body").css("overflow", "hidden");
			$(this)
				.css({
					"width": "",
					"height": "",
					"overflow": "",
					"position": "",
					"min-height": "",
					"max-height": ""
				})
				.closest(".ui-dialog")
				.css({ position: "", left: "", right: "", top: "", bottom: "", width: "", height: "" });

			var completeHandler = callback ? function(latLng) {
				mapPopup.dialog("close");
				callback(latLng);
			} : null;
			var cancelHandler = function () {
				mapPopup.dialog("close");
			};
			var spinner = getSpinner().appendTo(mapPopup);
			loadGoogleMapApi(function () { initMap(id, spinner, latLng, zoom, type, completeHandler, cancelHandler); });
		},
		close: function() {
			$("body").css("overflow", "");
		}
	});
}

function parseLocation(value) {
	// parse dms
	if(/^\s*$/.exec(value))
		return null;
	var m = /^\s*(\d+)\s*°(?:\s*(\d+)\s*['′])?(?:\s*(\d+(?:\.\d+)?)\s*["″])?\s*([NS])(?:(?:\s*[,;]\s*)|\s+)(\d+)\s*°(?:\s*(\d+)\s*['′])?(?:\s*(\d+(?:\.\d+)?)\s*["″])?\s*([EW])\s*$/i.exec(value);
	if(m) {
		return {
			lat: round((m[1] * 1 + (m[2] || 0) / 60 + (m[3] || 0) / 3600) * (m[4].toUpperCase() == "N" ? 1 : -1)),
			lng: round((m[5] * 1 + (m[6] || 0) / 60 + (m[7] || 0) / 3600) * (m[8].toUpperCase() == "E" ? 1 : -1))
		};
	}
	// parse degrees
	m = /^\s*(-?\d+(?:\.\d+)?)(?:(?:\s*[,;]\s*)|\s+)(-?\d+(?:\.\d+)?)\s*$/.exec(value);
	if(m) {
		return {
			lat: round(m[1] * 1),
			lng: round(m[2] * 1)
		};
	}
	// undefined = error
}

function processSrcSet(value, processor) {
	if(value) {
		var parts = value.split(",");
		for(var i = 0; i < parts.length; i++) {
			var part = parts[i];
			var n = part.lastIndexOf(" ");
			parts[i] = processor(part.substring(0, n)) + part.substring(n);
		}
		value = parts.join(",");
	}
	return value;
}

function updateMapImages(ctx) {
	var w = $(window);
	var vpTop = w.scrollTop(),
		vpLeft = w.scrollLeft(),
		vpRight = vpLeft + w.width(),
		vpBottom = vpTop + w.height();
	$("a.td-location.td-map > img.td-delayload[data-src]", ctx).each(function () {
		function patchURL(mapURL) {
			if(userGoogleMapApiKey) {
				var n = mapURL.indexOf("?");
				var qs = $.qstring(mapURL.substring(n));
				qs.remove("signature");
				qs.set("key", userGoogleMapApiKey);
				mapURL = mapURL.substring(0, n + 1) + qs.toString();
			}
			return mapURL.replace(/^\s*https?:/, "");
		}
		var img = $(this);
		var imgOffset = img.offset(),
			imgWidth = img.width(),
			imgHeight = img.height();
		if(imgOffset.left + imgWidth > vpLeft &&
			imgOffset.top + imgHeight > vpTop &&
			imgOffset.left < vpRight &&
			imgOffset.top < vpBottom) {
			var mapSrc = patchURL(img.attr("data-src"));
			var mapSrcSet = processSrcSet(img.attr("data-srcset"), patchURL);
			img.fadeTo(0, 0)
				.attr({ "src": mapSrc, "srcset": mapSrcSet, "data-src": null, "data-srcset": null })
				.on("load", function () { $(this).fadeTo(300, 1); });
		}
	});
}
$(window).on("scroll resize", function () { updateMapImages(); });

addCallback(updateMapImages);

$.fn.locationpicker = function() {
	this.each(function() {
		var e = $(this);
		var options = { zoom: 17, type: "roadmap" };
		try { options = { ...options, ...JSON.parse(e.attr("data-options") ?? "{}") }; } catch (e) { }
		function setValue(latLng) {
			var value = latLng.lat + ", " + latLng.lng;
			if(e.val() != value) {
				e.val(value).trigger("change");
			}
		}
		function getCurrentLocation(button) {
			function disable(state) { button.prop("disabled", state).toggleClass("ui-animate", state); }
			disable(true);
			getLocation(function(latLng/*, message*/) {
				if(latLng)
					setValue(latLng);
				disable(false);
			});
		}
		var insertAfter = this;
		var titleText;
		if(!e.parent("span.ui-input-group").length) {
			e.wrap($("<span>", { "class": "ui-input-group td-location-edit" }));
			if(locationSupported) {
				titleText = TD.Res["location.current"];
				insertAfter = $("<button>", { "type": "button", "class": "ui-button ui-icon-only ui-input-group-middle ui-icon-compass", "title": titleText })
					.on("click", function() {
						getCurrentLocation($(this));
					})
					.append($("<span>", { "class": "ui-icontext" }).text(titleText))
					.insertAfter(this);

				if(e.hasClass("td-use-currentlocation") && e.val() == "") {
					insertAfter.click();
				}
			}
			titleText = TD.Res["location.select"];
			$("<button>", { "type": "button", "class": "ui-button ui-icon-only ui-input-group-end ui-icon-map", "title": titleText })
				.on("click", function() {
					var latLng = parseLocation(e.val());
					displayMap(latLng, options, setValue);

				})
				.append($("<span>", { "class": "ui-icontext" }).text(titleText))
				.insertAfter(insertAfter);
		}
	});
	/*
	if(this.length) {
		var me = this;
		function initAutoCompleteForLocationBoxes(me) {
			me.each(function() {
				var me = this;
				var autocomplete = new googleMaps.places.Autocomplete(me);
				autocomplete.addListener("place_changed", function() {
					var place = autocomplete.getPlace();
					if(place.geometry) {
						$(me).val(round(place.geometry.location.lat()) + ", " + round(place.geometry.location.lng())).trigger("change");
					}
				});
			});
		}
		loadGoogleMapApi(function () { initAutoCompleteForLocationBoxes(me); });
	}*/
	return this;
};

var pinBase = "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z";
var defColor = "#FC6355";

function createSymbol(extra, color, select) {
	color = $.Color(color || defColor);
	if(select) {
		color = color.saturation(1).lightness(0.5);
	}
	color = color.toHexString();
	return {
		path: pinBase + extra,
		fillColor: color,
		fillOpacity: 1,
		strokeColor: '#000',
		strokeWeight: 1,
		scale: 1
	};
}

function pinSymbol(color, select) {
	return createSymbol(" M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0", color, select);
}

function spiderSymbol(color) {
	return createSymbol(" M 0,-35 l 0,10 M -5,-30 l 10,0", color);
}

function renderMapView(options) {

	var center = { lat: 0, lng: 0 }, zoom = 1, hasBounds = false, bounds = { north: -200, east: -200, south: 200, west: 200 };

	if (options.pins.length > 0) {
		zoom = 17;
		for (var i = 0; i < options.pins.length; i++) {
			var pin = options.pins[i];
			bounds.north = Math.max(bounds.north, pin.lat);
			bounds.south = Math.min(bounds.south, pin.lat);
			bounds.east = Math.max(bounds.east, pin.lng);
			bounds.west = Math.min(bounds.west, pin.lng);
		}
		center = { lat: (bounds.north + bounds.south) / 2, lng: (bounds.east + bounds.west) / 2 };
		hasBounds = options.pins.length > 1;
	}

	function selectMarker(marker, select) {
		marker.setIcon(pinSymbol(marker.pinData.color, select));
	}

	function initInteractiveView(spinner) {
		var oms, currentInfoWindow, currentMarker;
		spinner.remove();
		var map = new googleMaps.Map(document.getElementById(options.id), {
			mapTypeId: options.type,
			center: center
		});
		function iwClose() {
			if (currentInfoWindow) {
				currentInfoWindow.close();
				iwCloseCallback();
			}
		}
		function iwCloseCallback() {
			currentInfoWindow = null;
			selectMarker(currentMarker, 0);
			currentMarker = null;
		}
		function iwOpen(marker) {
			iwClose();
			var id = marker.pinData.id;
			currentMarker = marker;
			selectMarker(currentMarker, 1);
			currentInfoWindow = new googleMaps.InfoWindow({ content: document.getElementById(id).cloneNode(true), maxWidth: 640 });
			currentInfoWindow.open(map, marker);
			googleMaps.event.addListener(currentInfoWindow, "closeclick", iwCloseCallback);
		}
		map.addListener("click", iwClose);
		var markers = [];
		for (i = 0; i < options.pins.length; i++) {
			pin = options.pins[i];
			var marker = new googleMaps.Marker({
				position: { lat: pin.lat, lng: pin.lng },
				title: pin.title,
				map: map
			});
			marker.pinData = pin;
			markers.push(marker);
		}
		if (options.cluster) {
			var maxZoom = 16;
			var onClusterClick = function (_event, cluster, map) {
				map.fitBounds(cluster.bounds);
				if (map.getZoom() > maxZoom)
					map.setZoom(maxZoom);
			};
			new MarkerClusterer({ map: map, markers: markers, onClusterClick: onClusterClick });
		}
		oms = new OverlappingMarkerSpiderfier(map, {
			markersWontMove: true,
			markersWontHide: true,
			// basicFormatEvents: true,
			keepSpiderfied: true
		});
		oms.addListener("format", function (marker, status) {
			marker.setIcon(
				status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE ||
					status == OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIED ?
					spiderSymbol(marker.pinData.color) :
					pinSymbol(marker.pinData.color));
		});
		for (var i = 0; i < markers.length; i++) {
			oms.trackMarker(markers[i], (function (marker) { return function () { iwOpen(marker); }; })(markers[i]));
		}

		if (options.cluster) {
			map.addListener("zoom_changed", function () {
				googleMaps.event.addListenerOnce(map, "idle", function () {
					oms.formatMarkers();
				});
			});
		}
		if (hasBounds) {
			map.fitBounds(bounds);
		} else {
			map.setZoom(zoom);
		}
	}

	var mapContainer = $('#' + options.id);
	var spinner = getSpinner().appendTo(mapContainer);
	var aspect = (window.innerHeight - 80/* height of tab bar */) / window.innerWidth;
	mapContainer.parent().css("padding-bottom", (100 * aspect) + "%");
	loadGoogleMapApi(function () { initInteractiveView(spinner); });
}

function loadDashboardMapStubs() {
	$("a.td-mapview > img.td-mapcontainer[data-src]").each(function () {
		function patchURL(mapURL, width, height) {
			var n = mapURL.indexOf("?");
			var qs = $.qstring(mapURL.substring(n));
			qs.set("map.w", width);
			qs.set("map.h", height);
			// user provided a key?
			if(userGoogleMapApiKey) {
				qs.set("map.k", userGoogleMapApiKey);
			}
			mapURL = mapURL.substring(0, n + 1) + qs.toString();
			return mapURL;
		}

		var img = $(this);
		var a = img.parent();
		a.css("padding-bottom", initialAspect * 100 + "%");
		var width = a.outerWidth();
		var height = a.outerHeight();
		var mapSrc = patchURL(img.attr("data-src"), width, height);
		var mapSrcSet = processSrcSet(img.attr("data-srcset"), function (value) { return patchURL(value, width, height); }) || null;

		img.attr({ "src": mapSrc, "srcset": mapSrcSet, "data-src": null, "data-srcset": null }).on("load", function() {
			$(this).css("position", "static")
			.parent().css({ "display": "inline-block", "width": "auto", "padding-bottom": 0 });
		});
	});
}

addCallback(loadDashboardMapStubs);

export { renderMapView };


